<template>
  <div>
    <breadcrumb/>
    <births-list></births-list>
  </div>
</template>

<script>
import BirthsList from "@/components/Births/BirthsList";
import Breadcrumb from "@/components/General/Breadcrumb";
export default {
  components: {
    BirthsList,
    Breadcrumb
  },
};
</script>